export default "__VITE_ASSET__Bu1iNAWV__"